import { HttpInterceptorFn } from '@angular/common/http';

const defaultCulture = 'es';

export const defaultLanguageInterceptor: HttpInterceptorFn = (request, next) => {
  return next(
    request.clone({
      setHeaders: { 'Accept-Language': defaultCulture },
    }),
  );
};
